const styles = (state = [], action) => {
  switch (action.type) {
    case 'STYLE_LAYER':
      return {
        ...state,
          [action.id]: { id: action.id, paint: action.paint },
      }
    default:
      return state
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/reducers/styles.js